export default "__VITE_ASSET__1hrDfDxq__"